import { style } from "@vanilla-extract/css";

import { theme } from "./theme.css";

export const focusVisible = style({
  outline: "2px solid transparent",
  selectors: {
    "&:focus-visible": {
      outlineColor: theme.colors.outline,
    },
  },
});

export const focusWithin = style({
  outline: "2px solid transparent",
  selectors: {
    "&:has(:focus-visible), &[data-active]": {
      outlineColor: theme.colors.outline,
    },
  },
});

export const focusWithinField = style({
  outline: "2px solid transparent",
  selectors: {
    "&:has(:focus-visible), &[data-active]": {
      outlineColor: theme.colors.outline,
    },
  },
});

export const focusWithinInset = style({
  outline: "2px solid transparent",
  outlineOffset: "-3px",
  selectors: {
    "&:has(:focus-visible)": {
      outlineColor: theme.colors.outline,
    },
  },
});

export const focusVisibleOffset = style({
  outline: "2px solid transparent",
  outlineOffset: "4px",
  selectors: {
    "&:focus-visible": {
      outlineColor: theme.colors.outline,
    },
  },
});

export const focusVisibleInset = style({
  outline: "2px solid transparent",
  outlineOffset: "-2px",
  selectors: {
    "&:focus-visible": {
      outlineColor: theme.colors.outline,
    },
  },
});
